var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4927 11.5036V22.6461C12.4927 22.6915 12.4895 22.7362 12.4834 22.78C13.015 22.6796 13.5344 22.4943 14.0207 22.2241L20.4272 18.6649C22.0543 17.761 23.0634 16.046 23.0634 14.1847V8.68437C23.0634 7.76331 22.8163 6.87808 22.3695 6.10923C22.3386 6.13304 22.3059 6.15523 22.2714 6.17561L14.58 10.7264L14.5773 10.728C13.9255 11.1187 13.2182 11.3774 12.4927 11.5036Z",
    fill: "#363538"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81205 2.43976L2.63618 4.20413C2.31515 4.38249 2.01817 4.59242 1.74826 4.82881L1.75244 4.83115L9.40702 9.13698C10.711 9.87049 12.3082 9.8481 13.5911 9.07833L13.5962 9.07529L14.8263 8.34754L6.21704 2.95992C6.01705 2.83476 5.87899 2.64807 5.81205 2.43976Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5055 1.49896L9.04268 0.644969C10.5906 -0.21499 12.4728 -0.214989 14.0207 0.64497L20.4272 4.20414C20.661 4.33401 20.882 4.48062 21.0891 4.642L16.6885 7.24568L7.5055 1.49896Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.576649 6.32249C0.204074 7.03989 0 7.84734 0 8.68437V14.1847C0 16.046 1.00911 17.761 2.63618 18.6649L9.04268 22.2241C9.52903 22.4943 10.0484 22.6796 10.58 22.78C10.5739 22.7362 10.5707 22.6915 10.5707 22.6461V11.5302C9.8418 11.424 9.12736 11.1848 8.46474 10.8121L0.810161 6.50626C0.720909 6.45606 0.642771 6.39373 0.576649 6.32249Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStorage);
export default __webpack_public_path__ + "static/media/icon-storage.2e3ea0b242048b1874db39f94c83825b.svg";
export { ForwardRef as ReactComponent };